<template>
  <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="25" cy="25" r="25" :class="[orderStep > 1 ? 'status-active' : 'status-inactive']" />
    <path
      d="M39.714 17.2952L25.2312 10.0545C25.1594 10.0187 25.0803 10 25 10C24.9197 10 24.8406 10.0187 24.7688 10.0545L10.286 17.2952C10.2001 17.3381 10.1278 17.4042 10.0772 17.486C10.0267 17.5677 9.99996 17.662 10 17.7581V32.2393C9.99948 32.3359 10.026 32.4307 10.0765 32.5129C10.1271 32.5952 10.1997 32.6617 10.286 32.7048L24.7688 39.9455C24.8406 39.9813 24.9197 40 25 40C25.0803 40 25.1594 39.9813 25.2312 39.9455L39.714 32.7048C39.8003 32.6617 39.8729 32.5952 39.9235 32.5129C39.974 32.4307 40.0005 32.3359 40 32.2393V17.7581C40 17.662 39.9733 17.5677 39.9228 17.486C39.8723 17.4042 39.7999 17.3381 39.714 17.2952ZM25 24.4205L20.9567 22.3988L33.8805 15.5342L38.3288 17.7581L25 24.4205ZM16.8188 20.33L29.7426 13.4654L32.7426 14.9653L19.8203 21.8309L16.8188 20.33ZM16.2069 21.1808L19.3103 22.7324V26.8533L18.1243 25.6674C18.0273 25.5704 17.8958 25.5159 17.7586 25.5159H16.2069V21.1808ZM25 11.0956L28.6062 12.8965L15.6824 19.7622L11.6738 17.7581L25 11.0956ZM11.0345 18.5949L15.1724 20.6636V26.0331C15.1724 26.1702 15.2269 26.3018 15.3239 26.3988C15.4209 26.4958 15.5525 26.5503 15.6897 26.5503H17.5445L19.4619 28.4675C19.5342 28.5398 19.6264 28.589 19.7267 28.609C19.827 28.6289 19.931 28.6187 20.0255 28.5796C20.12 28.5404 20.2008 28.4741 20.2576 28.3891C20.3145 28.3041 20.3448 28.2041 20.3448 28.1018V23.2496L24.4828 25.3183V38.6432L11.0345 31.9197V18.5949ZM25.5172 38.6432V25.3183L38.9655 18.5949V31.9197L25.5172 38.6432Z"
      fill="white" stroke="white" stroke-width="0.3" />
  </svg>
</template>

<script>
export default {
  name: "statusPreparing",
  props: {
    orderStep: Number
  }
};
</script>

<style scoped>
.status-active {
  fill: var(--v-secondary-base);
}

.status-inactive {
  fill: #dbdbdb;
}
</style>
